// build: 2026-07-17b (fuerza hash nuevo tras caché de CDN envenenada)
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import 'mapbox-gl/dist/mapbox-gl.css';
import "./i18n";
import { installSessionGuard } from "./utils/sessionGuard";
import { startItineraryPrefetch } from "./utils/prefetchItinerary";
import { SeoProvider } from "./components/SEO/SeoProvider";

installSessionGuard();
startItineraryPrefetch();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <React.StrictMode>
      <SeoProvider>
        <App />
      </SeoProvider>
    </React.StrictMode>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
